import { Button } from "antd";
import WhiteStar from "../..//assets/images/whiteStar.svg";
import { IFileStatus } from "../../utils/interfaces/jobData";

interface NotificationDescriptionProps {
    type: "success" | "error" | "progress";
    status?: IFileStatus | null;
    onClose: () => void;
}

export default function NotificationDescription({type, status, onClose}: NotificationDescriptionProps) {
    if (type === "success") {
        return (
            <div className="pb-2.5 pl-4 pr-3.5">
                <img className="inline mr-2.5" src={WhiteStar} alt="white Star" />
                Resumes uploaded successfully
                <Button type="primary" onClick={onClose} style={{ marginLeft: "10px" }}>
                    Close
                </Button>
            </div>
        );
    }

    if (type === "error") {
        return (
            <div className="pb-2.5 pl-4 pr-3.5 bg-red-700">
                <img className="inline mr-2.5" src={WhiteStar} alt="white Star" />
                Resumes upload failed
                <Button type="primary" onClick={onClose} style={{ marginLeft: "10px" }}>
                    Close
                </Button>
            </div>
        );
    }

    return (
        <div className="pb-2.5 pl-4 pr-3.5">
            <img className="inline mr-2.5" src={WhiteStar} alt="white Star" />
            Analyzing uploaded resume{status?.totalFiles && status.totalFiles > 1 ? "s" : ""}{" "}
            <span className="ml-2.5 font-semibold">
                {status?.fileCount} of {status?.totalFiles}
            </span>
        </div>
    );
}
